import React from 'react';
import { Form, Input, InputNumber } from 'antd';
const { Group } = Input;

const MinimumOrderAmount = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Пассажировместимость" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('minimumOrderAmountFrom')(
          <InputNumber style={{ width: '50%' }} placeholder="от" min={0} />
        )}
        {getFieldDecorator('minimumOrderAmountTo')(
          <InputNumber style={{ width: '50%' }} placeholder="до" min={0} />
        )}
      </Group>
    </Form.Item>
  );
};

export default MinimumOrderAmount;
